import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Animations {
    constructor() {
        this.init();
    }

    init() {

        // --- SHOW / HIDE NAV ---
        const showhideNav = gsap.from('.nav-sticky', {
            opacity: 0,
            paused: true,
            duration: .5
        }).progress(1);

        ScrollTrigger.create({
            start: "top top",
            end: 99999,
            onUpdate: (self) => {
                const navSticky = document.querySelector('.nav-sticky');

                if (self.direction === -1) {
                    showhideNav.play();
                    navSticky.classList.add('has-bg');
                } else {
                    showhideNav.reverse();
                    navSticky.classList.add('has-scrolled');
                }

                const body = document.querySelector("body");
                const minScrollTop = body.classList.contains("admin-bar") ? 32 : 0;

                if (window.scrollY <= minScrollTop) {
                    navSticky.classList.remove('has-scrolled');
                    navSticky.classList.remove('has-bg');
                }
            }
        });


        // --- PARALLAX EFFECT ---
        gsap.utils.toArray(".img-container .parallax").forEach((section, i) => {
            const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
            gsap.timeline({
                scrollTrigger: {
                    trigger: section.parentElement,
                    scrub: true,
                    invalidateOnRefresh: true
                }
            })
                .fromTo(section, {
                    y: -heightDiff
                }, {
                    y: 0,
                    ease: "none"
                });
        });

    }
}